/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API47307Item {
  
  /** 业务域id */
  domainId: string;
  
  /** 业务域名称 */
  domainName?: string;
  
  /** 负责人信息 ,BaseUserDTO */
  principals?: API47307Item[];
  
};
    
  



  export type API47307Req = {};



export interface API47307Res {
  /** T  */
  list?: API47307Item[];
  
};


// 47307 系统负责人业务域维护列表

export interface IUseGetAPI47307Return {
  /** 系统负责人业务域维护列表: 接口请求状态 */
  isAPI47307Loading: boolean;
  /** 系统负责人业务域维护列表: 接口请求返回数据 */
  dataAPI47307: API47307Res;
  /**  系统负责人业务域维护列表: 接口数据请求方法 */
  fetchAPI47307Data:  ( config?: YWRequestConfig) => Promise<API47307Res>;
  /** 系统负责人业务域维护列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47307 = ():IUseGetAPI47307Return => {
  let isMount = true;
  const [isAPI47307Loading, setIsAPI47307Loading] = useState(false);
  const [dataAPI47307, setDataAPI47307] = useState<API47307Res>({} as API47307Res);
  const requestUrl = `${basePath}/ywwl-admin/biz/domain/maintain/list`;

  const fetchAPI47307Data = async ( config?: YWRequestConfig): Promise<API47307Res> => {
  
    if ( isMount ) {
      setIsAPI47307Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47307Res>(`${basePath}/ywwl-admin/biz/domain/maintain/list`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47307(res || {} as API47307Res);
        setIsAPI47307Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47307Loading(false);
      }
      return false as unknown as API47307Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47307Loading,
    dataAPI47307,
    fetchAPI47307Data,
    requestUrl,
  }
}

